function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.439 512.439",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m294.856 512.149c-.412 0-.825-.017-1.24-.051-6.469-.534-11.86-5.168-13.359-11.483l-51.834-218.251-216.823-50.456c-6.337-1.475-11.001-6.867-11.547-13.352-.545-6.484 3.151-12.581 9.154-15.094l482.439-202.008c5.617-2.353 12.103-1.073 16.407 3.237 4.305 4.311 5.574 10.797 3.213 16.413l-202.589 481.858c-2.353 5.599-7.828 9.187-13.821 9.187zm-231.251-298.941 180.664 42.042c5.543 1.29 9.879 5.606 11.194 11.144l43.365 182.59 170.565-405.689z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLight);
export default __webpack_public_path__ + "static/media/NavLight.8a6848bfc9f49a37c3781273b62f5285.svg";
export { ForwardRef as ReactComponent };